import React from 'react';
import { useParams } from 'react-router-dom';
import useBackendApi from '../../../../../hooks/useBackendApi';
import { getTestimonials } from '../../../../../services';
import { ITestimonial } from '../../../../../types/testimonial';

export default function useTestimonialContainerData(
  url,
  options = {
    hideLoader: false,
    fetch: true,
  }
) {
  const { profileId, categorySlug, appointmentId }: any = useParams();
  const { get } = useBackendApi();
  const [testimonials, setTestimonials] = React.useState<ITestimonial[]>([]);

  React.useEffect(() => {
    const fetch = async () => {
      const res = await getTestimonials(
        get,
        {
          profileId,
          categorySlug,
          appointmentId,
        },
        { loader: !options.hideLoader }
      );
      setTestimonials(res.data.docs);
    };
    if (profileId && (categorySlug || appointmentId) && !url && options.fetch) {
      fetch();
    }
  }, [profileId, categorySlug, appointmentId, url]);

  React.useEffect(() => {
    const fetch = async () => {
      const res = await get(url, {}, { loader: !options.hideLoader });
      setTestimonials(res.data.docs);
    };
    if (url && options.fetch) {
      fetch();
    }
  }, [url]);

  return { testimonials };
}
